const airports_reducer = (country, city) => {
  return {
    ...city.airports.reduce(
      (accumulator, currentValue) => ({
        ...accumulator,
        [currentValue.name.replaceAll('"', '').trim()]: {
          country_name: country.name,
          country_code: country.code,
          city_name: city.name,
          city_code: city.code,
          airport_name: currentValue.name,
          airport_code: currentValue.code,
          is_city: false,
        },
      }),
      {}
    ),
  };
};

const cities_reducer = (country) => {
  return {
    ...country.cities.reduce(
      (accumulator, currentValue) => ({
        ...accumulator,
        ...airports_reducer(country, currentValue),
      }),
      {}
    ),
  };
};

const countries_reducer = (accumulator, currentValue) => ({
  ...accumulator,
  ...cities_reducer(currentValue),
});

const cities_reducer_all = (country) => {
  return {
    ...country.cities
      .filter((city) => city.airports.length > 1)
      .reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.name.replaceAll('"', '').trim()]: {
            country_name: country.name,
            country_code: country.code,
            city_name: currentValue.name,
            city_code: currentValue.code,
            is_city: true,
            airports: currentValue.airports,
          },
        }),
        {}
      ),
  };
};

const countries_reducer_all = (accumulator, currentValue) => ({
  ...accumulator,
  ...cities_reducer_all(currentValue),
});

const countryParser = (data) => {
  if (data) {
    const parsed_countries = data.reduce(countries_reducer, {});
    const parsed_countries_all = data.reduce(countries_reducer_all, {});

    const airports = Object.entries(parsed_countries).map((e) => e[1]);
    const cities = Object.entries(parsed_countries_all).map((e) => e[1]);

    return [...cities, ...airports];
  }
};

export default countryParser;
